import React, { Component } from 'react';
import Highcharts from 'highcharts';

import { reset, highlight, storeOriginalFunctions } from '../../utils/highcharts-utils';
import Chart from '../Charts/Chart';

export default class SyncedCharts extends Component {
  constructor(props) {
    super(props);

    this.chartInstances = {};
    this.containerRef = React.createRef();
  }

  registerChartInstance = (id, chartInstance) => {
    this.chartInstances[id] = chartInstance;
  };

  syncHover = (e) => {
    let chart, point, event;

    for (const chartId in this.chartInstances) {
      chart = this.chartInstances[chartId];
      // Find coordinates within the chart
      event = chart.pointer.normalize(e);
      // Get the hovered point
      point = chart.series[0].searchPoint(event, true);

      if (point) {
        point.highlight(e);
      }
    }
  };

  hideTooltips = (e) => {
    for (const chartId in this.chartInstances) {
      this.chartInstances[chartId].tooltip.hide();
    }
  };

  componentDidMount() {
    // Store original functions before overriding
    storeOriginalFunctions(Highcharts);

    Highcharts.Pointer.prototype.reset = reset;
    Highcharts.Point.prototype.highlight = highlight;

    const container = this.containerRef.current;
    ['mousemove', 'touchmove', 'touchstart'].forEach((eventType) => {
      const passive = eventType.startsWith('touch');
      container.addEventListener(
        eventType,
        this.syncHover,
        passive ? { passive: true } : false
      );
    });

    container.addEventListener('mouseout', this.hideTooltips);
  }

  componentWillUnmount() {
    const container = this.containerRef.current;
    ['mousemove', 'touchmove', 'touchstart'].forEach((eventType) => {
      container.removeEventListener(eventType, this.syncHover);
    });
    container.removeEventListener('mouseout', this.hideTooltips);
  }

  render() {
    const size = this.props.size;
    return (
      <div ref={this.containerRef} role="group" aria-label="Synchronized charts group">
        {this.props.charts.map((chart) => (
          <Chart
            key={chart.id}
            {...chart}
            size={[size[0], chart.height ? chart.height : size[1]]}
            registerInstance={this.registerChartInstance}
          />
        ))}
      </div>
    );
  }
}
